import React from "react";
import { motion } from "motion/react";
import icon1 from "@images/values/1.png";
import icon2 from "@images/values/2.png";
import icon3 from "@images/values/3.png";
import icon4 from "@images/values/4.png";
import icon5 from "@images/values/5.png";

const valuesList = [
    {
        id: 1,
        icon: icon1,
        title: "الاحترافية والتميز",
        description: `التزام بأعلى مستويات الجودة من خلال فريق عمل متخصص وخبرة واسعة في التجارة الإلكترونية والتسويق الرقمي، لضمان تميز مشروعك`,
    },
    {
        id: 2,
        icon: icon2,
        title: "العميل أولاً",
        description: `نضع مصلحة العميل ونجاح مشروعه على رأس أولوياتنا، بدعم من ضماناتنا المالية وتيسير الدفعات لضمان نمو مشروعك بكل احترافية`,
    },
    {
        id: 3,
        icon: icon3,
        title: "الإبداع والابتكار",
        description: `نحن محرك لتحويل الأفكار التقليدية إلى تقنيات متطورة، باستخدام أحدث الأدوات والحلول المبتكرة لتوهج علامتك التجارية`,
    },
    {
        id: 4,
        icon: icon4,
        title: "الشفافية والثقة",
        description: `نبني علاقاتنا على الوضوح التام والنزاهة، ونضمن الشفافية في جميع مراحل العمل كـ شريك حقيقي تثق به`,
    },
    {
        id: 5,
        icon: icon5,
        title: "السرعة والكفاءة",
        description: `نُقدّر قيمة الوقت؛ نلتزم بتنفيذ وتسليم المشاريع في أسرع وقت ممكن، مع الحفاظ على أعلى معايير الدقة والجودة`,
    },
];

const OurValues = () => {
    return (
        <section className="section">
            <div className="wrapper">
                <div className="text-center max-w-2xl mx-auto mb-10 lg:mb-14">
                    <h2 className="line-sided-title mb-4">قيمنا</h2>
                    <p className="text-gray-600 text-sm sm:text-base">
                        مجموعة من المبادئ الراسخة التي توجه كل خطوة عمل نقوم بها لضمان نجاح عملائنا
                    </p>
                </div>

                <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                    {valuesList.map((item, idx) => (
                        <motion.div
                            key={`value-item-${item.id}`}
                            className="flex flex-col items-center text-center gap-4 py-8 px-6 rounded-2xl bg-white shadow-[0_4px_15px_0_rgba(0,0,0,0.06)] hover:shadow-[0_10px_30px_0_rgba(0,0,0,0.08)] transition-shadow duration-300"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{
                                duration: 0.5,
                                delay: (idx % 3) * 0.12,
                                ease: [0.25, 0.1, 0.25, 1],
                            }}
                        >
                            <img
                                src={item.icon}
                                alt={item.title}
                                className="w-16 h-16 object-contain"
                                loading="lazy"
                                decoding="async"
                            />
                            <p className="text-lg font-black text-gray-900">{item.title}</p>
                            <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurValues;
